import React from 'react';
import { motion } from 'framer-motion';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import HeroSlider from '../components/HeroSlider';
import Introduction from '../components/Introduction';
import DoctorProfile from '../components/DoctorProfile';
import Gallery from '../components/Gallery';
import VideoGallery from '../components/VideoGallery';
import Award from '../components/Award';
import Testimonials from '../components/Testimonials';
import GoogleMap from '../components/GoogleMap';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <motion.div
      className="home-page page-load-shell"
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <TopBar />
      <Navbar />
      <HeroSlider />
      <Introduction />
      <DoctorProfile />
      <Award />
      <Gallery />
      <VideoGallery />
      
     {/*  <Testimonials /> */}
      <GoogleMap />
      <Footer />
    </motion.div>
  );
};

export default Home;
